
export async function retryFailedRequests(
  { auth, host },
  projectId,
  param,
  fn,
  isIncidentDetailWithPageAPI = false,
  maxRetries = 4,
  retryDelay = 10000
) {
  if (isIncidentDetailWithPageAPI) {
    return await getIncidentDetail(auth, host, projectId, param, fn);
  } else {
    return await retrySingleParam(param, auth, host, projectId, maxRetries, retryDelay, fn);
  }
}


const isValid = (data) => !data.error;

export async function batchAPICalls(
  auth,
  extension,
  projectId,
  params,
  fn,
  isIncidentDetailWithPageAPI = false
) {
  const host = extension?.config?.env?.clientApiGateway?.URL;
  const results = [];

  if (projectId === "PROJ0040466" || projectId === "PROJ0040017") {
    const batchSize = 10;

    async function processBatch(batch) {
      return Promise.all(
        batch.map(param =>
          retryFailedRequests({ auth, host }, projectId, param, fn, isIncidentDetailWithPageAPI)
        )
      );
    }

    for (let i = 0; i < params.length; i += batchSize) {
      const batch = params.slice(i, i + batchSize);
      const batchResults = await processBatch(batch);
      results.push(...batchResults);
    }
    return results;
  } else {
    const promises = params.map(param => {
      if (isIncidentDetailWithPageAPI) {
        return getIncidentDetail(auth, host, projectId, param, fn).catch(err => ({ data: [], error: err }));
      } else {
        return retrySingleParam(param, auth, host, projectId, 4, 10000, fn).catch(err => ({ data: [], error: err }));
      }
    });

    return await Promise.all(promises);
  }
}


async function getIncidentDetail(auth, host, projectId, param, getIncidentDetailWithPage) {
  let results = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    const currentParam = `${param}&page_size=400&page=${page}`;
    auth.token = sessionStorage.getItem("auth");

    let result;
    try {
      result = await retrySingleParam(currentParam, auth, host, projectId, 4, 10000, getIncidentDetailWithPage);
    } catch (error) {
      return { data: [], error: "Failed to get data" };
    }

    try {
      results.push(...(result.data?.incidents || []));
      const pagination = result.data?.pagination;
      hasNext = pagination?.has_next;
      page++;
    } catch (error) {
      return { data: [], error: "Failed to parse data" };
    }
  }

  const incidentMap = new Map();
  try {
    results.forEach(incident => {
      const { incident_number, inc_updated_at } = incident;
      const currentDate = new Date(inc_updated_at);
      if (!incidentMap.has(incident_number)) {
        incidentMap.set(incident_number, incident);
      } else {
        const existingIncident = incidentMap.get(incident_number);
        const existingDate = new Date(existingIncident?.inc_updated_at);
        if (currentDate > existingDate) {
          incidentMap.set(incident_number, incident);
        }
      }
    });

    return { data: Array.from(incidentMap.values()), error: null };
  } catch (error) {
    return { data: [], error: error.message || error };
  }
}


async function retrySingleParam(param, auth, host, projectId, maxRetries, retryDelay, fn) {
  let attempt = 0;
  while (attempt < maxRetries) {
    try {
      auth.token = sessionStorage.getItem('auth');
      const response = await fn({ auth, host }, projectId, param);
      if (isValid(response)) {
        return response;
      }
    } catch (error) {
      console.log("Attempt", attempt + 1, "failed:", error);
    }
    attempt++;
    await new Promise(resolve => setTimeout(resolve, retryDelay));
  }
  return { data: [], error: "Failed After Retry" };
}
